<template>
    <div>
        <div class="ap-workspace-head">
            <div class="ap-workspace-label">
                <div class="ap-workspace-label-name">
                    Продукция
                </div>
                <div class="ap-workspace-label-btn" v-on:click="showModal">
                    <SVGPlus/>
                </div>
            </div>
            <div class="ap-workspace-label-btn ap-add-left-margin">
                <label class="ap-search">
                    <input type="text" class="ap-search-input" placeholder="Найти продукт" v-model="mask">
                </label>
            </div>
        </div>
        <vue-custom-scrollbar @ps-y-reach-end="scrollReachEnd">
            <div class="ap-workspace-table-container workspace-admin-scroll-part">
                <table class="result-table">
                    <thead>
                    <tr class="head-tr">
                        <th>№</th>
                        <th>Название</th>
                        <th>Категория</th>
                        <!--                    <th>Цвет</th>-->
                        <!--                    <th>Тип продукции</th>-->
                        <th>Изображение</th>
                        <th class="field-edit">Опции</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="body-tr row" v-for="(value, index) in products">
                        <td>
                            <span class="table-data">{{index+1}}</span>
                        </td>
<!--                        <td>-->
<!--                            <div class="ap-table-uuid-holder" v-on:click="showModalUUID(value.uuid)">-->
<!--                                <SVGLabel style="margin: 2px 0"/> UUID-->
<!--                            </div>-->
<!--                            <span class="table-data-central">{{value.uuid}}</span>-->
<!--                        </td>-->
                        <td>
                            <span class="table-data">{{value.name}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{getCategoryByIds(value.hierarchy_ids).name}}</span>
                        </td>
                        <!--                    <td>-->
                        <!--                        <span class="table-data">{{value.color}}</span>-->
                        <!--                    </td>-->
                        <!--                    <td>-->
                        <!--                        <span class="table-data">{{value.type}}</span>-->
                        <!--                    </td>-->
                        <td>
                            <img class="ap-table-img product-img" :src="urlForPhoto(value.preview)"/>
                        </td>
                        <td>
                            <div class="edit-button-group">
                                <div class="table-svg-button" v-on:click="editRow(value)">
                                    <SVGAdminEditRow/>
                                </div>
                                <div class="table-svg-button" v-on:click="confirm(value)">
                                    <SVGAdminDeleteRow/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="waitingResponseToProductRequest" class="ap-loader-grid">
                    <SpinnerTwo/>
                    <div class="ap-loader-text">
                        Идет загрузка продукции ...
                    </div>
                </div>
            </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow.vue";
    import SVGAdminDeleteRow from "../../SVG/SVGAdminDeleteRow.vue";
    import SVGPlus from "../../SVG/SVGPlus";
    import {urlForStaticVue} from "../../common";
    import SVGSearch from "../../SVG/SVGSearch";
    import AddProduct from "../../Modal/AdminPage/ProductsPage/AddProduct";
    import ChangeProduct from "../../Modal/AdminPage/ProductsPage/ChangeProduct";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import SpinnerTwo from "../../SpinnerTwo";
    import SVGLabel from "../../SVG/SVGLabel";
    import ModalUUID from "../../Modal/AdminPage/ModalUUID";
    import ModalConfirmation from "../../Modal/ModalConfirmation";

    export default {
        name: "AdminProducts",
        mixins: [urlForStaticVue],
        components: {
            SVGLabel,
            SpinnerTwo,
            SVGSearch,
            SVGPlus,
            SVGAdminDeleteRow,
            SVGAdminEditRow,
            vueCustomScrollbar
        },
        data(){
          return {
              timerId: null
          }
        },
        computed: {
            mask:{
                get() {
                    return this.$store.state.adminPanel.products.mask;
                },
                set(value) {
                    this.$store.commit('adminPanel/products/MASK', value);
                    if (this.timerId) {
                        clearTimeout(this.timerId);
                        this.timerId = null;
                    }
                    this.timerId = setTimeout(() => {
                        this.$store.commit('adminPanel/products/CLEAR_PRODUCTS');
                        this.$store.dispatch('adminPanel/products/GET_PRODUCTS');
                        this.timerId = null;
                    }, 500);
                }
            },
            products() {
              return this.$store.getters["adminPanel/products/SELF"];
          },
            waitingResponseToProductRequest(){
              return this.$store.state.adminPanel.products.waitingResponseToProductRequest;
            }
        },
        methods: {
            scrollReachEnd() {
                this.$store.dispatch('adminPanel/products/GET_PRODUCTS');
            },
            getCategoryByIds(ids){
              return this.$store.getters["adminPanel/categories/CATEGORY_BY_HIERARCHY_IDS"](ids);
            },
            urlForPhoto(url) {
                return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
            },
            showModal(){
                this.$modal.show(AddProduct, {}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 660,
                    draggable: true,
                });
            },
            deleteRow(productUUID) {
                return () => {this.$store.dispatch('adminPanel/products/DELETE_PRODUCT', productUUID)};
            },
            confirm(product) {
                const title = `Удалить продукт "${product.name}"?`
                const text = 'Запись о данном продукте будет безвозвратно удалена, хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.deleteRow(product.uuid)}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
            editRow(dataProduct) {
                this.$modal.show(ChangeProduct, {dataProduct}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 660,
                    draggable: true,
                });
            },
            // showModalUUID(uuid) {
            //     this.$modal.show(ModalUUID, {uuid}, {
            //         height: 'auto',
            //         pivotY: 0.2,
            //         width: 516
            //     });
            // }
        },
        mounted() {
            this.$store.dispatch('adminPanel/products/GET_PRODUCTS');
            this.$store.dispatch('adminPanel/categories/GET_CATEGORIES');
        }
    }
</script>

<style scoped>
.product-img{
    width: 150px;
    height: 65px;
    object-fit: cover;
}
</style>
